import { makeObservable, observable } from 'mobx'

import i18n from 'modules/core/lib/i18n'

import { AttachedFile } from './AttachedFile'
import { Block, BlockConfig } from './Block'

export type PageBlockConfig = BlockConfig & {
  description?: string
  thumbnail?: AttachedFile
}

export class PageBlock extends Block {
  description: string
  thumbnail: AttachedFile

  constructor(config: PageBlockConfig = {}) {
    super(config)

    this.description = config.description || ''
    this.thumbnail = config.thumbnail || new AttachedFile()

    makeObservable(this, {
      description: observable,
      thumbnail: observable,
    })
  }

  validate(): Record<string, string> {
    const errors = { ...super.validate() }
    if (!this.description.trim()) {
      errors.description = i18n.t('trainings.content.validation.description_required')
    }
    return errors
  }

  clone(): PageBlock {
    return new PageBlock({
      uuid: this.uuid, // Preserve uuid for tracking
      title: this.title,
      description: this.description,
      thumbnail: this.thumbnail,
    })
  }
}
